/**
 * Automatisch weiterfuehren (F-34 E1, Schalter, Standard aus): haelt den
 * Kalender fuer die naechsten X Wochen gefuellt - einmal je Tag und beim
 * Einschalten. Zeigt nichts an.
 */
import { useEffect } from 'react';
import { useLiveQuery } from 'dexie-react-hooks';

import { db } from '@/db/schema';
import { rollierendAuffuellen } from '@/db/repositories/trainingKalender';
import { today } from '@/lib/datetime';

let laeuft: Promise<unknown> | null = null;
let zuletzt = '';

export function KalenderPflege() {
  const k = useLiveQuery(() => db.trainingsEinstellungen.get('standard').then((e) => e?.kalender), []);
  const an = Boolean(k?.rollierend);
  const wochen = k?.wochen ?? 0;
  const heute = today();
  useEffect(() => {
    const schluessel = `${heute}|${wochen}`;
    if (!an || laeuft || zuletzt === schluessel) return;
    zuletzt = schluessel;
    laeuft = rollierendAuffuellen(heute).finally(() => { laeuft = null; });
  }, [an, wochen, heute]);
  return null;
}
